module.exports = __webpack_public_path__ + "img/kbank.a03cf5e3.png";